module.exports = __webpack_public_path__ + "d44ac354be40097be4dd1cb1adfdd454.svg";